// Shown on every screen but Account when the Carveny Mileage subscription has ended, or never
// started. Restoring in the app keeps working until the deletion date.

import { StateCard, Steps } from "../components/Controls.tsx";
import { useAccountData } from "../data/AccountData.tsx";
import { formatLongDate } from "../domain/format.ts";
import { linkHandler } from "../lib/router.ts";

export function Lapsed() {
  const { status } = useAccountData();
  const ended = status.subscribedUntil !== null;

  if (!ended) {
    return (
      <StateCard icon="lock" title="Carveny Online comes with Carveny Mileage" id="lapsed-title">
        <p>Subscribe in Carveny on your iPhone, then turn on backup. Your trips appear here after the first upload.</p>
        <Steps label="Get started" steps={[
          <>In Carveny, subscribe to <b>Carveny Mileage</b>.</>,
          <>Go to <b>Trips › Trip Settings › Carveny Online</b> and turn it on.</>,
          <>Sign in with this Apple ID, then come back here.</>,
        ]} />
        <div style={{ marginTop: 22, display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
          <a className="cv-btn cv-btn-secondary" href="https://apps.apple.com/app/carveny">Get Carveny on the App Store</a>
        </div>
        <AccountLink />
      </StateCard>
    );
  }

  return (
    <StateCard icon="calendar" iconTint="var(--amber-fill)" title="Your Carveny Mileage subscription has ended" id="lapsed-title">
      <p>Carveny Online comes with Carveny Mileage. Subscribe again in Carveny on your iPhone to use this website and keep backing up.</p>
      {status.dataDeletedAfter && (
        <div className="cv-notice" style={{ marginTop: 20, textAlign: "left", display: "block" }}>
          <p>Your trips stay online until <b>{formatLongDate(status.dataDeletedAfter)}</b>.</p>
          <p className="cv-hint" style={{ marginTop: 2 }}>Until then you can restore them to any iPhone, with or without a subscription.</p>
        </div>
      )}
      <Steps label="Restore your trips" steps={[
        <>Open <b>Carveny</b> on your iPhone.</>,
        <>Go to <b>Trips › Trip Settings › Carveny Online</b>.</>,
        <>Tap <b>Restore Trips</b> and sign in with this Apple ID.</>,
      ]} />
      <AccountLink />
    </StateCard>
  );
}

function AccountLink() {
  return (
    <p style={{ marginTop: 20 }}>
      <a href="/account" onClick={linkHandler("/account")}>Account, sign out or delete your online account</a>
    </p>
  );
}
